var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterBoilerNotFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.839 57h-31.6c-4.529 0-8.2-3.671-8.2-8.2v-29.802h48v29.802c0 4.529-3.671 8.2-8.2 8.2z",
    fill: "#f0dbc2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45.839 57h-31.6c-4.529 0-8.2-3.671-8.2-8.2v-29.802h48v29.802c0 4.529-3.671 8.2-8.2 8.2z",
    fill: "#f0dbc2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45.839 57c4.529 0 8.2-3.671 8.2-8.2v-29.72l-0.022-0.083-38.002 38.003z",
    fill: "#e6ccaf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.24 51.563h27.597c2.873 0 5.201-2.329 5.201-5.201v-23.737c-1.896-0.224-3.852 0.202-5.507 1.306-2.752 1.834-6.337 1.834-9.089 0-2.752-1.835-6.337-1.835-9.089 0-2.752 1.834-6.337 1.834-9.089 0-1.574-1.049-3.42-1.478-5.227-1.326v23.757c2e-3 2.872 2.331 5.201 5.203 5.201z",
    fill: "#aade87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m49.039 23.976-27.587 27.587h22.386c2.873 0 5.201-2.329 5.201-5.201z",
    fill: "#5aa02c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m15.001 2.332 34.773 9.317c3.201 0.858 5.1 4.148 4.243 7.348l-46.364-12.422c0.857-3.201 4.147-5.1 7.348-4.243z",
    fill: "#6a636e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m36.039 56.5c0 3.59-2.686 6.5-6 6.5s-6-2.91-6-6.5 6-9.5 6-9.5 6 5.911 6 9.5z",
    fill: "#f82938"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m21.039 56.5c0 3.59-2.686 6.5-6 6.5s-6-2.91-6-6.5 6-9.5 6-9.5 6 5.911 6 9.5z",
    fill: "#f82938"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m7.007 12.601c0.225-1.716 1.677-3.046 3.454-3.046 0.303 0 0.591 0.05 0.872 0.123 0.743-1.83 2.532-3.123 4.628-3.123 2.213 0 4.068 1.447 4.727 3.439 0.874-1.455 2.452-2.439 4.273-2.439 2.761 0 5 2.239 5 5 0 1.231-0.462 2.343-1.199 3.214 1.846 0.561 3.199 2.257 3.199 4.286 0 2.485-2.015 4.5-4.5 4.5-1.055 0-2.013-0.378-2.78-0.986-0.624 1.737-2.269 2.986-4.22 2.986-1.758 0-3.265-1.018-4.005-2.488-1.683 0.836-3.774 0.573-5.177-0.83-0.702-0.702-1.111-1.58-1.252-2.492-0.729 0.508-1.611 0.81-2.566 0.81-2.485 0-4.5-2.015-4.5-4.5 0-2.33 1.777-4.224 4.046-4.454z",
    fill: "#89a8ec"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.961,
    cy: 13.555,
    r: 2,
    fill: "#cfdef2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.961,
    cy: 17.555,
    r: 3,
    fill: "#cfdef2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.961,
    cy: 34.778,
    r: 3,
    fill: "#89a8ec"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.938,
    cy: 42.64,
    r: 3,
    fill: "#89a8ec"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m57.039 43.515v-23.515c0-3.866-3.134-7-7-7s-7 3.134-7 7v23.515c-2.856 2.359-4.502 6.132-3.863 10.248 0.745 4.802 4.716 8.599 9.543 9.161 6.665 0.776 12.32-4.413 12.32-10.923 0-3.416-1.557-6.468-4-8.486z",
    fill: "#fb8276"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m53.039 45.683v-17.683h-6v17.683c-2.363 1.124-4 3.526-4 6.317 0 3.866 3.134 7 7 7s7-3.134 7-7c0-2.79-1.637-5.193-4-6.317z",
    fill: "#e21e2c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m38.226 9.555c-0.086 0-0.173-0.011-0.26-0.034-0.533-0.143-0.85-0.691-0.707-1.225 0.713-2.663-0.873-5.41-3.536-6.124-2.657-0.711-5.409 0.873-6.124 3.535-0.144 0.534-0.69 0.852-1.225 0.707-0.534-0.143-0.851-0.691-0.707-1.225 1-3.728 4.842-5.952 8.573-4.949 3.729 0.998 5.949 4.845 4.95 8.573-0.119 0.447-0.523 0.742-0.964 0.742z",
    fill: "#463c4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBoilerNotFail);
export default __webpack_public_path__ + "static/media/water_boiler_not_fail.af24a8d42994fcaa69e302d6df2a2633.svg";
export { ForwardRef as ReactComponent };